module.exports = __webpack_public_path__ + "static/media/websites.07650652.webp";